import { gql } from 'apollo-boost';
import Breadcrumbs from 'core/components/common/Breadcrumbs';
import { useLinks } from 'core/components/linksContext';
import { container, pageHeader, title } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';
import { BrokerOrderEnum, useGetBrokersQuery } from 'site/graphql';
import BrokerOtherTable from './BrokerOtherTable';
import BrokersMainTable from './BrokersMainTable';
import { BROKERS_MAIN_COUNT } from './const';
import TextBlock from '../pages/TextBlock';

gql`
    query GetBrokers($filter: BrokerListRequest) {
        brokers(filter: $filter) {
            count
            result {
                id
                name
                link
                about
                commission
                minimum
                features
                sentence
                position
                pictureId
            }
        }
    }
`;

const BrokerList: React.FC<WithStyles<typeof styles>> = ({ classes }) => {
    const links = useLinks();
    const { data } = useGetBrokersQuery({ variables: { filter: { order: BrokerOrderEnum.Position } } });
    const brokers = (data && data.brokers && data.brokers.result) || [];

    const mainBrokers = brokers.slice(0, BROKERS_MAIN_COUNT);
    const otherBrokers = brokers.slice(BROKERS_MAIN_COUNT);

    return (
        <>
            <div className={classes.header}>
                <h1>Список брокеров</h1>
            </div>
            <div className={classes.container}>
                <Breadcrumbs
                    contrast={false}
                    items={[
                        { href: links.home.url(), title: 'Главная' },
                        { href: links.servicePage.url(), title: 'Сервисы инвестора' },
                        { title: 'Выбрать брокера' },
                    ]}
                />
                <TextBlock slug="page-brokers" />
                {mainBrokers.length > 0 && <BrokersMainTable brokers={mainBrokers} />}
                {otherBrokers.length > 0 && (
                    <div>
                        <h3 className={classes.titleMore}>Больше брокеров</h3>
                        <BrokerOtherTable brokers={otherBrokers} />
                    </div>
                )}
            </div>
        </>
    );
};

const styles = (theme: ITheme) =>
    createStyles({
        header: {
            ...pageHeader(theme),
        },
        container: container(theme, { gutter: 0 }),
        titleMore: {
            ...title({ mode: 'left', size: 'h3' }),
            marginBottom: 0.5 + 'rem',
        },
    });

export default injectSheet(styles, 'BrokerList')(BrokerList);
